import React, { PureComponent } from "react";
import get from "lodash/get";

import { COLORS } from "@eventbrite/valkyrie-eds-styles/color";
import {
  VectorImage,
  VectorImageProps,
} from "@eventbrite/valkyrie-eds-vector-image";

import * as constants from "./constants";

import { getIconVectorType, iconNameMatches } from "./util";

export type IconProps = Omit<VectorImageProps, "svg" | "type"> & {
  /**
   * The type of icon that you want to display e.g. alert
   */
  type: VectorImageProps["svg"];
  /**
   * The size of the icon
   */
  size?: (typeof constants.SIZES)[number];
  /**
   * The fill color of the icon
   */
  color?: (typeof COLORS)[number]; // TODO: this resolves to a string because COLORS is a computed array
  /**
   * The stroke color of the icon
   */
  strokeColor?: (typeof COLORS)[number]; // TODO: this resolves to a string because COLORS is a computed array
  /**
   * The title of the icon
   */
  title?: string | String;
};

export class Icon extends PureComponent<IconProps> {
  static defaultProps = {
    size: "small",
  };

  render() {
    const { type, size, color, strokeColor, title, ...vectorImageProps } =
      this.props;
    let overrideColor: string | undefined = color;
    let overrideStrokeColor: string | undefined = strokeColor;

    // Default the color to a theme color no color has been specified.
    // This way the icons will be themable

    // NOTE: Below is commented out until we can properly theme all
    // the places icons are used (EB-99689)
    // if (!overrideColor && !overrideStrokeColor) {
    //     overrideColor = 'ui-700';
    // }

    // Clear out defaulted color for logo icons
    if (!color && iconNameMatches(type, (name) => name.startsWith("logo-"))) {
      overrideColor = undefined;
    }

    // if the icon type is one that should use a stroke color instead of fill
    // color, replace the fill color with the stroke color
    if (!strokeColor) {
      const isStrokeIcon = !!constants.STROKE_COLOR_ICONS.find(
        (strokeColorIcon) =>
          strokeColorIcon.displayName === get(type, "type.displayName"),
      );

      if (isStrokeIcon) {
        overrideStrokeColor = overrideColor;
        overrideColor = undefined;
      }
    }

    return (
      <VectorImage
        {...vectorImageProps}
        type={getIconVectorType(type)}
        svg={type}
        size={size}
        color={overrideColor}
        strokeColor={overrideStrokeColor}
      />
    );
  }
}
